import axios from 'axios';

const $axios = axios.create({
    baseURL: `${process.env.VUE_APP_URL_RW}/api`,
    headers: {
        Authorization: 'Bearer ' +  localStorage.getItem('token'),
        'Content-Type': 'application/json'
    }
});

export default $axios;
